import getCurrentHostname from 'src/js/router/utils/get-current-hostname';
import getDomain from './domain';

const getIsB2C = (rootState) => getCurrentHostname() === getDomain(rootState);

export default getIsB2C;
